import React, { Suspense } from 'react';
import { lazyRetry, loadComponent } from 'MODULES/lazyRetry';
import { Loader } from 'COMMON/loader';
import { useRouteMatch } from 'react-router';
import ParentLanding from 'COMPONENTS/home/landings/parent';


const HomeMobile = loadComponent(() => lazyRetry(() => import('CONTAINERS/home_mobile')));

const HomeMobileWrapper = (props) => {
    const match = useRouteMatch();
    let categoriesFromLink = match.params[0] || '';
    categoriesFromLink = categoriesFromLink.split('/');
    const categorySlug = categoriesFromLink[0];

    return (
        <div>
            {!categorySlug && <ParentLanding i18n={props.i18n} lang={props.lang} />}
            <Suspense fallback={<div style={{ minHeight: '1156px' }}>{Loader}</div>}>
                <div style={{ minHeight: '1156px' }}>
                    <HomeMobile {...props} />
                </div>
            </Suspense>
        </div>
    );
};

export default HomeMobileWrapper;
